// src/components/Gallery.jsx

import React, { useEffect, useState } from "react";
import { storage } from "../firebaseConfig";
import { ref, listAll, getDownloadURL } from "firebase/storage";
import "./Gallery.css";

const Gallery = () => {
  // Holds all image URLs from Firebase
  const [images, setImages] = useState([]);

  // Tracks which image is currently shown
  const [currentIndex, setCurrentIndex] = useState(0);

  // Controls fullscreen viewer (lightbox)
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  // Fetch images from Firebase Storage
  const fetchImages = async () => {
    try {
      const folderRef = ref(storage, "workspaces/AfDsQf3a4HNfZrIY28qrTnNPUzN2/websites/f2v0M4bYufyU4t6IQh04/assets/Website Gallery/");
      const result = await listAll(folderRef);

      const urls = await Promise.all(
        result.items.map((item) => getDownloadURL(item))
      );

      setImages(urls);
    } catch (error) {
      console.error("Error loading gallery images:", error);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Show next image
  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  // Show previous image
  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  // Open fullscreen viewer
  const openViewer = () => {
    setIsViewerOpen(true);
  };

  // Close fullscreen viewer
  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  if (images.length === 0) return null;

  return (
    <section id="gallery" className="gallery">
      <h2 className="gallery-title">Fleur Gallery</h2>

      {/* Slideshow */}
      <div className="gallery-slider">
        <button className="arrow left" onClick={prevImage}>
          ❮
        </button>

        <img
          src={images[currentIndex]}
          alt="Gallery"
          className="gallery-image"
          onClick={openViewer}
        />

        <button className="arrow right" onClick={nextImage}>
          ❯
        </button>
      </div>

      {/* Fullscreen Viewer */}
      {isViewerOpen && (
        <div className="viewer-overlay">
          <button className="close-btn" onClick={closeViewer}>
            ✕
          </button>

          <button className="arrow left" onClick={prevImage}>
            ❮
          </button>

          <img
            src={images[currentIndex]}
            alt="Full view"
            className="viewer-image"
          />

          <button className="arrow right" onClick={nextImage}>
            ❯
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
